import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ChartBarPartModel } from '../../models/chart.model';
import { FeaturePropertyKey } from '../../../../../projects/client';

@Component({
  selector: 'app-chart-bar-description',
  templateUrl: './chart-bar-description.component.html',
  styleUrls: ['./chart-bar-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartBarDescriptionComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;

  @Input() barParts: ChartBarPartModel[];
  @Input() alignNumbers: string;

  ngOnInit(): void {
    this.alignNumbers = this.alignNumbers || 'center';
  }
}
